import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 * Motor Breadcrumb params
 */
export default class FromPageNameToNewsBreadcrumbVOMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Function} deps.valueObject
   */
  constructor({config, valueObject}) {
    super({
      config,
      valueObject
    })
    this._config = config
    this._valueObject = valueObject
  }

  _sanitize(label) {
    return label.charAt(0).toUpperCase() + label.slice(1)
  }

  _normalizeWordSeparators(label) {
    return label.split('-').join(' ').split('_').join(' ')
  }

  _getCategory(category) {
    return category ? this._sanitize(category) : 'BREADCRUMB_HOME_LABEL'
  }

  _getTerm(term) {
    return this._normalizeWordSeparators(term)
      .split(' ')
      .map(word => this._sanitize(word))
      .join(' ')
  }

  _getLabel({term, category}) {
    return term && !category ? this._getTerm(term) : this._getCategory(category)
  }

  _getNewsSectionTipsBreadcrumbs = ({params}) => {
    const {NEWS_SECTION_TIPS_PATH_PATTERN: url} = this._config.get('page')
    return [
      {label: 'NAVIGATION_MAIN_NEWS_COCHES_TIPS', url},
      {
        label: this._getLabel(params)
      }
    ]
  }

  _getNewsSectionTrendsBreadcrumbs = ({params}) => {
    const {NEWS_SECTION_TRENDS_PATH_PATTERN: url} = this._config.get('page')
    return [
      {label: 'NAVIGATION_MAIN_NEWS_COCHES_TRENDS', url},
      {
        label: this._getLabel(params)
      }
    ]
  }

  _getNewsTagPageBreadcumbs = ({params: {term}}) => {
    const {NEWS_HOME_PATH_PATTERN: url} = this._config.get('page')
    const {BREADCRUMBS_ROOT_LITERAL} = this._config.get('editorial')
    return [
      {label: BREADCRUMBS_ROOT_LITERAL, url},
      {
        label: this._getLabel({term})
      }
    ]
  }

  _getNewsDefaultBreadcumbs = ({params}) => {
    const {NEWS_HOME_PATH_PATTERN: url} = this._config.get('page')
    const {BREADCRUMBS_ROOT_LITERAL} = this._config.get('editorial')

    return [
      {label: BREADCRUMBS_ROOT_LITERAL, url},
      {
        label: this._getLabel(params)
      }
    ]
  }

  map({pageName, params}) {
    const {NEWS_SECTION_TIPS_PAGE_NAME, NEWS_SECTION_TRENDS_PAGE_NAME, NEWS_TAG_PAGE_NAME} = this._config.get('page')

    let breadcrumbs

    switch (pageName) {
      case NEWS_SECTION_TIPS_PAGE_NAME:
        breadcrumbs = this._getNewsSectionTipsBreadcrumbs({params})
        break
      case NEWS_SECTION_TRENDS_PAGE_NAME:
        breadcrumbs = this._getNewsSectionTrendsBreadcrumbs({params})
        break
      case NEWS_TAG_PAGE_NAME:
        breadcrumbs = this._getNewsTagPageBreadcumbs({params})
        break
      default:
        breadcrumbs = this._getNewsDefaultBreadcumbs({params})
        break
    }

    return this._valueObject({breadcrumbs})
  }
}
